import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'

import { HorizonError } from '@moment/horizon-data-access'
import { toError } from '@moment/observability/logger'

import { createLogger } from '@/lib/logger'

const logger = createLogger('legacy-api/account-query-sorm')

/**
 * Runs a SORM fetch inside an RTK Query `queryFn`, reporting failures as
 * `FetchBaseQueryError`s so callers see the same error shape as the legacy
 * `account/query/` path (including the HTTP status for 429 retries).
 */
export async function runSormQuery<T>(
  queryName: string,
  fetch: () => Promise<T>,
): Promise<{ data: T } | { error: FetchBaseQueryError }> {
  try {
    return { data: await fetch() }
  } catch (error) {
    logger.error('Account SORM query failed', {
      error: toError(error),
      queryName,
    })
    if (error instanceof HorizonError) {
      return { error: { status: error.status, data: error.data } }
    }
    return {
      error: {
        status: 'CUSTOM_ERROR',
        error: error instanceof Error ? error.message : String(error),
      },
    }
  }
}
